import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import styled from "styled-components";
import BtnElement from "../elements/BtnElement";
import { AppColors } from "../styles/colors";

interface BackButtonProps {
  onClick: () => void;
  className?: string;
}

const StyledBackButton = styled(BtnElement)`
  padding: 0;
  color: ${AppColors.onSurface}; /* 명시적으로 검정색 설정 */
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    font-size: 20px;
  }
`;

export default function BackButton({ onClick, className }: BackButtonProps) {
  return (
    <StyledBackButton
      $fullWidth={false}
      $variant="text"
      $size="small"
      onClick={onClick}
      className={className}
    >
      <ArrowBackIosNewIcon />
    </StyledBackButton>
  );
}
